import {
  Card,
  Paragraph,
  ShareSolidRegular,
  View,
  XStack,
} from '@ninjacart/nc-nk-ui';
import { t } from 'i18next';
import { Alert, Share, Pressable } from 'react-native';
import { useEffect, useRef, useState } from 'react';
import {
  useQueuedEventStore,
  addEventParam,
  INinjaEvent,
} from '@ninjacart/nc-events-sdk-v2';
import { UserProps, KissanEventType } from '@ninjacart/nc-nk-store';
import { copyToClipboard } from '../utils/clipboard'; // or your relative import

const ReferralCode = ({ refCode, userProfile }: { refCode: string; userProfile: UserProps; }) => {
  const [copied, setCopied] = useState(false);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  useEffect(() => {
    let timer;
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [copied]);

  const handleReferralCodeCopyEvent = () => {
    const referralCopyEvent: INinjaEvent = {
      name: KissanEventType.REFERRAL_COPY,
      screenDetails: { screen: 'profile detail page' },
      eventParams: [
        addEventParam('referralCode', refCode ?? ''),
        addEventParam('contactNumber', userProfile?.user?.primaryPhoneNumber),
      ],
    };
    enqueue(referralCopyEvent);
  };

  const handleReferralCodeShareEvent = () => {
    const referralShareEvent: INinjaEvent = {
      name: KissanEventType.REFERRAL_SHARE,
      screenDetails: { screen: 'profile detail page' },
      eventParams: [
        addEventParam('referralCode', refCode ?? ''),
        addEventParam('contactNumber', userProfile?.user?.primaryPhoneNumber),
      ],
    };
    enqueue(referralShareEvent);
  };

  const handleCopy = async () => {
    await copyToClipboard(refCode ?? '');
    handleReferralCodeCopyEvent();
    setCopied(true);
  };

  const handleShare = async () => {
    handleReferralCodeShareEvent();
    try {
      const playStoreUrl = `http://play.google.com/store/apps/details?id=com.ninja.kisaan&refferalCode=${userProfile?.user.referralCode}`;
      await Share.share({ message: playStoreUrl });
    } catch (error) {
      Alert.alert(error.message);
    }
  };

  const formatNumberWithSpaces = (referralCode) =>
    referralCode?.match(/.{1,3}/g)?.join(' ') ?? '';

  return (
    <XStack>
      <Card width={'100%'} marginVertical={2} backgroundColor="$cardbackground">
        <View padding={15}>
          <XStack flexDirection="row" justifyContent="space-between">
            <Paragraph size={14} fontWeight={'500'} paddingBottom={3}>
              {t('page.referYourFriendsFamily')}
            </Paragraph>
            <Pressable onPress={handleShare}>
              <View
                flexDirection="row"
                padding={6}
                borderRadius={50}
                alignItems="center"
                testID="kisan_tId_share_referralCode_click"
              >
                <ShareSolidRegular size={18} color={'$primary'} />
                <Paragraph fontSize={13} fontWeight={'600'} paddingLeft={5}>
                  {t('page.share')}
                </Paragraph>
              </View>
            </Pressable>
          </XStack>

          <XStack flexDirection="row" marginTop={5}>
            <Paragraph fontSize={17} fontWeight={'600'} color={'$primary'}>
              {formatNumberWithSpaces(refCode)}
            </Paragraph>
            <Pressable onPress={handleCopy} disabled={copied}>
              <Paragraph
                paddingLeft={15}
                fontSize={14}
                fontWeight={'500'}
                color={'$primary'}
                testID="kisan_tId_copy_referralCode_click"
              >
                {copied ? t('page.copied') : t('page.copyCode')}
              </Paragraph>
            </Pressable>
          </XStack>
        </View>
      </Card>
    </XStack>
  );
};

export default ReferralCode;
